import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import img1 from "../assets/workshops/dataScience.png"
import img2 from "../assets/workshops/ml.png";
import img3 from "../assets/workshops/web.png"


import { WhatWoix } from "../containers";

const Woix = () => {
  return (
    <>
    <div >
      <Carousel
        infiniteLoop
        autoPlay
        showStatus={false}
        showArrows={false}
        showThumbs={false}
        interval={1000}
      >
         <div>
          <img src={img3} alt="Item3" width={300} height={500} />
     
        </div>
        <div>
          <img src={img1} alt="Item1" width={300} height={500} />
        
        </div>
        <div>
          <img src={img2} alt="Item2" width={300} height={500} />
          
        </div>
        
        
        
       
      </Carousel>
    </div>
    <br/><br/><br/>
    <WhatWoix/>
    </>
  );
};

export default Woix;